import { render } from "./HdbtEventFormView.vue?vue&type=template&id=45c1a964&scoped=true"
import script from "./HdbtEventFormView.vue?vue&type=script&lang=js"
export * from "./HdbtEventFormView.vue?vue&type=script&lang=js"

import "./HdbtEventFormView.vue?vue&type=style&index=0&id=45c1a964&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c1a964"]])

export default __exports__